export default "__VITE_ASSET__Bf_aOcl___"